'use client';
import React, { createContext, useContext } from 'react';

export type RouterContextType = {
  push: (url: string, useNativeRouter?: boolean) => void;
  replace: (url: string, useNativeRouter?: boolean) => void;
  // Native (only)
  // url is optional, this is used to navigate back to a specific page
  // if spacific page not exists, this will behave as push(specific page)
  // if url is not provided, this will behave as back()
  back: (url?: string) => void;
  pathParams?: Record<string, string | string[] | undefined>;
  searchParams: URLSearchParams;
  pathname: string;
  getState?: () => {
    pathParams?: Record<string, string | string[] | undefined>;
    searchParams: URLSearchParams;
    pathname: string;
  };
};

const RouterStoreContext = createContext<RouterContextType | null>(null);

export const useRouter = () => {
  const store = useContext(RouterStoreContext);
  if (!store) {
    throw new Error('Missing RouterProvider');
  }
  return store;
};

export function InterfaceRouterProvider(props: {
  router: RouterContextType;
  children: React.ReactNode;
}) {
  return (
    <RouterStoreContext.Provider value={props.router}>{props.children}</RouterStoreContext.Provider>
  );
}
